// import { queryParameters, fetchJson } from "react-admin/lib/util/fetch";
import authenticatedHttpClient from "./authenticatedHttpClient";
import { API_URL } from "../config";
import {
    fetchUtils,
    GET_LIST,
    GET_ONE,
    GET_MANY,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    DELETE,
    DELETE_MANY,
    UPDATE_MANY
} from "react-admin";
import urlJoin from "url-join";
import pickBy from "lodash/pickBy";
import session, { USER_COMPANY_ID } from "./userSession";
const { queryParameters } = fetchUtils;
const GET_ROLE = "GET_ROLE";
const GET_LICENSED_INSTALLATION = "GET_LICENSED_INSTALLATION";
const UNLOCK = "UNLOCK";
const GET_ONE_BY_PARAMETERS = "GET_ONE_BY_PARAMETERS";
const UPDATE_NO_PREV = "UPDATE_NO_PREV";
const LICENSE_CHECK = "LICENSE_CHECK";

const myRestClient = (apiUrl, httpClient = fetchUtils.fetchJson) => {
    const convertRESTRequestToHTTP = (type, resource, params) => {
        let url = "";
        const options = {};
        options.headers = new Headers();
        switch (type) {
            case GET_ROLE:
                url = urlJoin(
                    apiUrl,
                    `/${resource}?${queryParameters(params)}`
                );
                break;
            case GET_LICENSED_INSTALLATION:
                url = urlJoin(
                    apiUrl,
                    `/${resource}?${queryParameters(params)}`
                );
                break;
            case GET_ONE_BY_PARAMETERS:
                url = urlJoin(
                    apiUrl,
                    `/${resource}?${queryParameters(params)}`
                );
                break;
            case UNLOCK:
                url = urlJoin(
                    apiUrl,
                    `/${resource}/${params.data.resource_id}`
                );
                if (params.data.locked !== null) {
                    delete params.data.resource_id;
                }

                options.method = "PATCH";
                options.body = JSON.stringify(params.data);
                break;
            case GET_LIST: {
                const { page, perPage } = params.pagination;
                const { field, order } = params.sort;

                let query = {
                    ...params.filter,
                    order: `${field},${order.toLowerCase()}`,
                    limit: perPage,
                    offset: (page - 1) * perPage
                };
                if (resource === "installations") {
                    query["select_url_like"] = true;
                    if (params["infoTransfer"]) {
                        query["ids"] = params["id_inst"];
                        query["isOperational"] = true;
                        query["hasOperationRunning"] = true;
                    }
                }
                if (resource === "operations" && params.filter_type) {
                    query["filter_type"] = params.filter_type;
                }
                if (
                    resource === "installation_types" &&
                    params.no_user_filter
                ) {
                    query["no_user_filter"] = params.no_user_filter;
                }
                url = urlJoin(apiUrl, `/${resource}?${queryParameters(query)}`);
                break;
            }
            case GET_ONE:
                if (params && params.userId) {
                    url = urlJoin(apiUrl, `/${resource}/${params.userId}`);
                } else if (params && params.id) {
                    url = urlJoin(apiUrl, `/${resource}/${params.id}`);
                } else {
                    url = urlJoin(apiUrl, `/${resource}`);
                }
                break;
            case GET_MANY: {
                url = urlJoin(
                    apiUrl,
                    `/${resource}?ids=${params.ids.join(",")}`
                );
                break;
            }
            case GET_MANY_REFERENCE: {
                const { page, perPage } = params.pagination;
                const { field, order } = params.sort;
                const query = {
                    [params.target]: params.id,
                    order: `${field},${order.toLowerCase()}`,
                    limit: perPage,
                    offset: (page - 1) * perPage,
                    ...params.filter
                };
                url = urlJoin(apiUrl, `/${resource}?${queryParameters(query)}`);
                break;
            }
            case UPDATE:
                url = urlJoin(apiUrl, `/${resource}/${params.id}`);
                options.method = "PATCH";
                let patch = pickBy(
                    params.data,
                    // Escludo la chiave 'licenses' perchè comportava il confronto dei nomi delle licenze e non i codici, generando errore
                    (value, key) =>
                        params.previousData[key] !== value && key !== "licenses"
                );
                if (resource === "users") {
                    if (patch.password_confirm) {
                        delete patch.password_confirm;
                    }
                    if (patch.new_password) {
                        patch.password = patch.new_password;
                        delete patch.new_password;
                    }
                }

                if (resource === "companies" && patch.master_company_id === 0) {
                    patch.master_company_id = null;
                }
                if (resource === "companies" && patch.installation_types) {
                    delete patch.installation_types;
                }
                if (resource === "tickets" && patch.result_lic) {
                    delete patch.result_lic;
                }
                options.body = JSON.stringify(patch);
                break;
            case UPDATE_NO_PREV:
                url = urlJoin(apiUrl, `/${resource}/${params.id}`);
                options.method = "PATCH";
                options.body = JSON.stringify(params.data);
                break;
            case CREATE:
                url = urlJoin(apiUrl, `/${resource}`);
                options.method = "POST";
                if (
                    resource === "companies" &&
                    params.data.master_company_id === 0
                ) {
                    delete params.data.master_company_id;
                }
                options.body = JSON.stringify(params.data);
                break;
            case DELETE:
                if (params.force) {
                    url = urlJoin(
                        apiUrl,
                        `/${resource}/${params.id}?force=true`
                    );
                } else {
                    url = urlJoin(apiUrl, `/${resource}/${params.id}`);
                }
                options.method = "DELETE";
                break;
            case DELETE_MANY:
                break;
            case UPDATE_MANY:
                break;
            case LICENSE_CHECK:
                url = urlJoin(apiUrl, `/${resource}`);
                options.method = "POST";
                options.body = JSON.stringify(params.data);
                break;
            default:
                throw new Error(`Unsupported fetch action type ${type}`);
        }
        return { url, options };
    };

    const convertHTTPResponseToREST = (response, type, resource, params) => {
        const { headers, json } = response;

        let total_records = +Infinity;
        switch (type) {
            case GET_LIST:
            case GET_MANY_REFERENCE: {
                total_records = parseInt(
                    headers.get("content-range"),
                    // .split("/")
                    // .pop(),
                    10
                );
                if (!total_records) total_records = 0;
                return { data: json, total: total_records };
            }
            case DELETE:
                if (resource === "installations") {
                    return {
                        data: {
                            id: params.id,
                            data: json
                        }
                    };
                }
                return { data: { id: params.id } };
            default:
                return { data: json };
        }
    };

    return (type, resource, params) => {
        const { url, options } = convertRESTRequestToHTTP(
            type,
            resource,
            params
        );
        // Fix when you update a record with no modified data you get internal server error - "empty update"
        if (
            type === UPDATE &&
            Object.keys(JSON.parse(options.body)).length === 0
        ) {
            return { data: { id: params.id } };
        }
        return httpClient(url, options)
            .then(response =>
                convertHTTPResponseToREST(response, type, resource, params)
            )
            .catch(e => {
                if (
                    e &&
                    e.message === "Missing 'user-company' header on request"
                ) {
                    /* authClient(aor.AUTH_LOGOUT) */
                    session.delete(USER_COMPANY_ID);
                    window.location.reload();
                } else {
                    throw e;
                }
            });
    };
};

//added in order to make a call from custom action
export default myRestClient(API_URL, authenticatedHttpClient);



// WEBPACK FOOTER //
// ./src/common/restClient.js